
export enum InstanceRoute {
    DIRECTION = 'direction',
    STATUS = 'status',
    DESTINATIONTYPE = 'destinationType'
  }
  
  export const instanceRoute = Object.values(InstanceRoute) as string[];
  